import { useMemo, useState } from 'react';
import { ImMNElement } from '../../../../../common/elements/elementModelTypes';
import { useSelector } from 'react-redux';
import getGridSize from '../../../../utils/grid/gridSizeSelector';
import { currentBoardCanvasElementsSelector } from '../../../../element/selectors/currentBoardSelector';
import { isBoard } from '../../../../../common/elements/utils/elementTypeUtils';
import { getTitle } from '../../../../../common/elements/utils/elementPropertyUtils';

type UseBoardLinkContentResult = {
    searchQuery?: string;
    setSearchQuery: (query: string) => void;
    gridSize: number;
    filteredBoards: ImMNElement[];
    handleBoardSelect: (board: ImMNElement) => void;
};

export const useBoardLinkContent = (): UseBoardLinkContentResult => {
    const [searchQuery, setSearchQuery] = useState<string | undefined>(undefined);
    const gridSize = useSelector(getGridSize);
    const currentBoardElements = useSelector(currentBoardCanvasElementsSelector);

    const boards = useMemo(() => {
        // TODO: Fetch/search boards
        return currentBoardElements.filter(isBoard).toArray();
    }, [currentBoardElements]);

    const filteredBoards = useMemo(() => {
        if (!searchQuery) return boards;

        const normalisedQuery = searchQuery.trim().toLowerCase();
        if (!normalisedQuery) return boards;

        return boards.filter((board: ImMNElement) => {
            const title = getTitle(board)?.toLowerCase();
            return title?.includes(normalisedQuery);
        });
    }, [boards, searchQuery]);

    const handleBoardSelect = (board: ImMNElement) => {
        // TODO: Insert the board link
    };

    return {
        searchQuery,
        setSearchQuery,
        gridSize,
        filteredBoards,
        handleBoardSelect,
    };
};
